<template>
	<div class="news-page">
		<!-- definePageMeta -->
		<Head>
			<Title>{{ `${$t('pages.news.meta_title')} | Carfree` }}</Title>
			<Meta v-if="config.public.environment === 'production-to-change'" name="robots" content="index, follow" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Meta name="description" :content="$t('pages.news.meta_description')" />
			<Link rel="canonical" :href="route.fullPath" />
		</Head>

		<div class="news-page__list-container">
			<NewsPageList />
		</div>
	</div>
</template>

<script setup lang="ts">
const route = useRoute()
const config = useNuxtApp().$config
definePageMeta({
	layout: 'news-catalog',
})

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	gtmService.pageViewed({ page_type: 'news' })
}

if (process.client) sendAnalyticsData()
</script>

<style lang="scss">
@import './index.scss';
</style>
